export const maxXS = 500
export const maxSM = 750
export const maxMD = 1023

export const bpMaxXS = `@media (max-width: ${maxXS}px)`
export const bpMaxSM = `@media (max-width: ${maxSM}px)`
export const bpMaxMD = `@media (max-width: ${maxMD}px)`